export const projectTypes = [
  'placeme.save_analyse.private',
  'placeme.save_analyse.public',
]
